import { Admin } from "@resamare/models";
import { createContext, useContext, useMemo } from "react";
import { useGetAdmin } from "../api/getAdmin";

const AdminContext = createContext<{ admin: Admin | null | undefined } | null>(null);

type AdminProviderProps = {
    children: React.ReactNode;
};

export function AdminProvider({ children }: AdminProviderProps) {
    const adminQuery = useGetAdmin();

    const contextValue = useMemo(
        () => ({
            admin: adminQuery.data,
        }),
        [adminQuery.data],
    );

    return <AdminContext.Provider value={contextValue}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
    const context = useContext(AdminContext);

    if (context === null) {
        return { admin: null };
    }

    return context;
}
